// src/components/LogoutWarningModal.tsx
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './LogoutWarningModal.css';

interface LogoutWarningModalProps {
  isOpen: boolean;
  onLogoutAnyway: () => void;
  onStayLoggedIn: () => void;
}

const LogoutWarningModal: React.FC<LogoutWarningModalProps> = ({
  isOpen,
  onLogoutAnyway,
  onStayLoggedIn
}) => {
  const { theme } = useTheme();

  if (!isOpen) {
    return null;
  }

  return (
    <div className={`logout-warning-overlay ${theme}`}>
      <div className="logout-warning-modal">
        <div className="logout-warning-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h2>Wait!</h2>
        <p>You are logging out without submitting a handoff for this shift.</p>
        <p className="logout-warning-subtext">Are you sure you want to continue?</p>
        <div className="logout-warning-buttons">
          <button className="logout-warning-btn logout-anyway-btn" onClick={onLogoutAnyway}>
            Log Out Anyway
          </button>
          <button className="logout-warning-btn stay-logged-in-btn" onClick={onStayLoggedIn}>
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutWarningModal;
